/**
 * ag-grid 한국어 locale
 * - Community 기능에 해당하는 텍스트 위주
 */
export const AG_GRID_LOCALE_KR: Record<string, string> = {
  // Set Filter (community not included, kept for safety)
  selectAll: '모두 선택',
  selectAllSearchResults: '검색 결과 모두 선택',
  searchOoo: '검색...',
  blanks: '(비어 있음)',
  noMatches: '일치하는 항목 없음',

  // Number Filter & Text Filter
  filterOoo: '필터...',
  equals: '같음',
  notEqual: '같지 않음',
  blank: '비어 있음',
  notBlank: '비어 있지 않음',
  empty: '선택하세요',

  // Number Filter
  lessThan: '미만',
  greaterThan: '초과',
  lessThanOrEqual: '이하',
  greaterThanOrEqual: '이상',
  inRange: '범위',
  inRangeStart: '시작',
  inRangeEnd: '끝',

  // Text Filter
  contains: '포함',
  notContains: '포함하지 않음',
  startsWith: '시작 문자',
  endsWith: '끝 문자',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',

  // Filter Conditions
  andCondition: 'AND',
  orCondition: 'OR',

  // Filter Buttons
  applyFilter: '적용',
  resetFilter: '초기화',
  clearFilter: '지우기',
  cancelFilter: '취소',

  // Filter Titles
  textFilter: '텍스트 필터',
  numberFilter: '숫자 필터',
  dateFilter: '날짜 필터',

  // Side Bar
  columns: '컬럼',
  filters: '필터',

  // columns tool panel
  pivotMode: '피벗 모드',
  groups: '행 그룹',
  rowGroupColumnsEmptyMessage: '행 그룹화할 컬럼을 드래그하세요',
  values: '값',
  valueColumnsEmptyMessage: '집계할 컬럼을 드래그하세요',
  pivots: '컬럼 라벨',
  pivotColumnsEmptyMessage: '컬럼 라벨을 드래그하세요',

  // Header of the Default Group Column
  group: '그룹',

  // Other
  loadingOoo: '불러오는 중...',
  noRowsToShow: '표시할 데이터가 없습니다',
  enabled: '사용',

  // Menu
  pinColumn: '컬럼 고정',
  pinLeft: '왼쪽 고정',
  pinRight: '오른쪽 고정',
  noPin: '고정 해제',
  valueAggregation: '집계',
  autosizeThiscolumn: '이 컬럼 자동 크기',
  autosizeAllColumns: '모든 컬럼 자동 크기',
  groupBy: '그룹 기준',
  ungroupBy: '그룹 해제',
  resetColumns: '컬럼 리셋',
  expandAll: '모두 펼치기',
  collapseAll: '모두 접기',
  copy: '복사',
  ctrlC: 'Ctrl+C',
  copyWithHeaders: '헤더 포함 복사',
  paste: '붙여넣기',
  ctrlV: 'Ctrl+V',
  export: '내보내기',
  csvExport: 'CSV 내보내기',

  // Enterprise Menu Aggregation and Status Bar
  sum: '합계',
  min: '최솟값',
  max: '최댓값',
  none: '없음',
  count: '개수',
  avg: '평균',
  filteredRows: '필터된 행',
  selectedRows: '선택된 행',
  totalRows: '전체 행',
  totalAndFilteredRows: '행',
  more: '더보기',
  to: '~',
  of: '/',
  page: '페이지',
  nextPage: '다음 페이지',
  lastPage: '마지막 페이지',
  firstPage: '첫 페이지',
  previousPage: '이전 페이지',
  pageLastRowUnknown: '?',
};
